import React, { useState } from "react";
import styled from "styled-components";
import SVG from "src/utils/SVG";

interface IReadOnlySwitchProps {
  checked?: boolean;
  onChange(): void;
}

const ReadOnlySwitch = (props: IReadOnlySwitchProps) => {
  const { checked, onChange } = props;

  return (
    <SwitchSet>
      <label>
        {checked ? <SVG name="switchActive" width={50} height={25} viewBox="0 0 50 25" /> : <SVG name="switch" width={50} height={25} viewBox="0 0 50 25" />}
        <input type="checkbox" onClick={onChange} />
      </label>
    </SwitchSet>
  );
};

const SwitchSet = styled.span`
  display: inline-block;
  > label {
    display: inline-block;
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
    }
  }
`;

export default ReadOnlySwitch;
